export const MAP_STATE_ERRORS = {
  DELETED: 'map.err.deleted',
  NOT_EXIST: 'element_not_exists',
  AUTHORISATION_NOT_ENABLED: 'err.authorisation.authorisation_not_enabled',
  NO_READY_FOR_AUTHORISATIONS_DIAGRAMS: 'err.authorisation.no_diagrams_for_authorisation'
} as const;

export const MAP_PERMISSION_ERRORS = {
  CANNOT_EDIT: 'map.err.rights.cannot_edit',
  CANNOT_VIEW: 'map.err.rights.cannot_view',
  DOES_NOT_EXIST: 'map.err.rights.does_not_exist',
  IS_PERSONAL: 'err.map.request_access_in_personal_space'
} as const;

export const ORGANIZATION_STATE_ERRORS = {
  NOT_FOUND: 'organization.not_found',
  SUSPENDED: 'team_suspended'
} as const;

export const DIAGRAM_STATE_ERRORS = {
  LOCKED: 'diagram.err.locked',
  NOT_EXIST: 'diagram.version.not.exist',
  VERSION_RESTRICTED: 'err.diagram.version-restricted',
  ATTACHMENT_WRONG_FORMAT: 'url_library.wrong_format_url_entry',
  ELEMENT_NOT_EXISTS: 'err.diagram.draw.element_not_exists',
  VALIDATION_FAILED: 'err.diagram.draw.validation_failed',
  KEY_ALREADY_EXISTS: 'err.diagram.draw.key_already_exists'
} as const;

export const DIAGRAM_PERMISSION_ERRORS = {
  CANNOT_EDIT: 'diagram_rights.cannot_edit',
  CANNOT_EDIT_NOTES: 'diagram_rights.cannot_edit_notes',
  NOT_REQUIREMENT_MANAGER: 'user.err.org_req_manager_rights_needed'
} as const;

export const USER_STATE_ERRORS = {
  USER_BLOCKED_IN_TEAM: 'user_in_team.blocked',
  ACCESS_DENIED: 'user.err.access-denied',
  NOT_PRO: 'team.err.is_not_pro',
  NOT_PRO_INFO: 'team.info.is_not_pro',
  USER_BLOCKED: 'user.err.blocked',
  USER_NOT_VERIFIED: 'user.err.user_is_not_verified',
  DELETED_BY_SYSTEM: 'user.err.deleted_from_system'
} as const;

export const IMPORT_DRILLDOWN_STATE_ERRORS = {
  NO_RIGHTS: 'import_drilldown.no_rights',
  NOT_EXIST: 'import_drilldown.source_map_not_exist'
} as const;

export const EXPORT_DRILLDOWN_STATE_ERRORS = {
  NO_RIGHTS: 'export_drilldown.no_rights',
  NOT_EXIST: 'export_drilldown.target_diagram_not_exist'
} as const;

export const CONNECTION_ERRORS = {
  NOT_THE_SAME_TEAM: 'connection.team.not.the.same'
} as const;

export const COMMENT_ERRORS = {
  DUPLICATED_STATUS: 'comment.reply.duplicated_status',
  COMMENT_RESOLVED: 'comment.resolved'
} as const;

export const RESOURCES_ERRORS = {
  ALREADY_EXIST: 'already_exist'
} as const;

export const PERMISSION_ERRORS = {
  ALREADY_EDITOR: 'diagram_rights.user_already_editor_in_diagram',
  NOT_IN_MAP: 'diagram_rights.user_not_in_map'
} as const;

export const CHANGELOGS_ERRORS = {
  NOT_FOUND: 'changelog.list.nothing_found'
} as const;

export const TRAINING_ERRORS = {
  NO_TRAINING: 'training.err.no_training_task',
  TRAINING_CANCELLED: 'training.err.training_cancelled_by_owner',
  TRAINING_TASK_ITEM_CANCELLED: 'diagram_training.status_cancelled',
  TRAINING_SAME_STATUS: 'diagram_training.task.same_status'
} as const;

export const AUTHORISATION_ERRORS = {
  NO_AUTHORISATION: 'authorisation.err.authorisation_task',
  TWO_FACTOR_REQUIRED: 'two_factor_required'
} as const;

export const LICENSE_ERRORS = {
  LICENSE_REQUIRED: 'license_required'
} as const;

export type DiagramPKServerErrorStatus =
  | (typeof MAP_STATE_ERRORS)[keyof typeof MAP_STATE_ERRORS]
  | (typeof MAP_PERMISSION_ERRORS)[keyof typeof MAP_PERMISSION_ERRORS]
  | (typeof ORGANIZATION_STATE_ERRORS)[keyof typeof ORGANIZATION_STATE_ERRORS]
  | (typeof DIAGRAM_STATE_ERRORS)[keyof typeof DIAGRAM_STATE_ERRORS]
  | (typeof DIAGRAM_PERMISSION_ERRORS)[keyof typeof DIAGRAM_PERMISSION_ERRORS]
  | (typeof USER_STATE_ERRORS)[keyof typeof USER_STATE_ERRORS]
  | (typeof IMPORT_DRILLDOWN_STATE_ERRORS)[keyof typeof IMPORT_DRILLDOWN_STATE_ERRORS]
  | (typeof EXPORT_DRILLDOWN_STATE_ERRORS)[keyof typeof EXPORT_DRILLDOWN_STATE_ERRORS]
  | (typeof CONNECTION_ERRORS)[keyof typeof CONNECTION_ERRORS]
  | (typeof COMMENT_ERRORS)[keyof typeof COMMENT_ERRORS]
  | (typeof RESOURCES_ERRORS)[keyof typeof RESOURCES_ERRORS]
  | (typeof PERMISSION_ERRORS)[keyof typeof PERMISSION_ERRORS]
  | (typeof CHANGELOGS_ERRORS)[keyof typeof CHANGELOGS_ERRORS]
  | (typeof TRAINING_ERRORS)[keyof typeof TRAINING_ERRORS]
  | (typeof AUTHORISATION_ERRORS)[keyof typeof AUTHORISATION_ERRORS];
